// extracted by mini-css-extract-plugin
export var buttonContainer = "_81-1";
export var fontSizeSelect = "_81-3";
export var formatSelect = "_81-2";
export var formats = "_81-4";
export var hidden = "_81-5";
export var icon = "_81-6";
export var select = "_81-0";